import { Model } from '@/models/Model';
export class DownloadTeacher extends Model {
    constructor() {
        super(...arguments);
        this.$endpoint = '/global-users/download-teachers';
        this.$name = 'DownloadTeacher';
        //#region relationship methods
        // async create(payload: DownloadTeachersPayload): Promise<any> {
        //   return super.create(payload);
        // }
        // public all(): Promise<any> {
        //   throw new Error('Method not allowed')
        // }
        // public update(attributes?: object): Promise<any> {
        //   throw new Error('Method not allowed')
        // }
        // public put(attributes?: object): Promise<any> {
        //   throw new Error('Method not allowed')
        // }
        // public delete(attributes?: object): Promise<any> {
        //   throw new Error('Method not allowed');
        // }
        //#endregion
        //#region Endpoints
        //#endregion
        //#region Class methods
        //#endregion
        //#region Getters & Setters
        //#endregion
    }
}
//#region Includes enum
export var GlobalUserIncludes;
(function (GlobalUserIncludes) {
    GlobalUserIncludes["TOKEN"] = "token";
    GlobalUserIncludes["SCHOOLS"] = "schools";
})(GlobalUserIncludes || (GlobalUserIncludes = {}));
//#endregion
